import FastModal from 'components/FastModal';
import ElementPrefixId from 'constants/elementPrefixId';
import {useIntl} from 'react-intl';
import {useDispatch, useSelector} from 'react-redux';
import {hideTypedModal} from 'stores/actions/typedModalAction';
import {getModalData} from 'stores/selectors/typedModalSelectors';
import {resetBackupRestoreState} from 'stores/business/backupAndRestoreBusiness';
import style from './ModalDownloadBackupDataFailed.module.scss';

function ModalDownloadBackupDataFailed() {
  const dispatch = useDispatch();
  const {formatMessage} = useIntl();
  const {errorNumber} = useSelector(getModalData);

  const content = (
    <div id={`${ElementPrefixId.MODAL_DOWNLOAD_BACKUP_DATA_FAILED}-container`} className={style.container}>
      <span className={style.description}>{formatMessage({id: 'modal.downloadBackupDataFailed.text'})}</span>
    </div>
  );

  const handleClickGotIt = () => {
    dispatch(resetBackupRestoreState());
    dispatch(hideTypedModal());
  };

  const buttons = [
    {
      className: 'btn-lg',
      style: 'primary',
      text: formatMessage({id: 'modal.downloadBackupDataFailed.button.gotIt'}),
      handlerClick: handleClickGotIt,
    },
  ];

  return (
    <FastModal
      show
      header={formatMessage({id: 'modal.downloadBackupDataFailed.title'})}
      content={content}
      errorCodeNumber={errorNumber}
      btnAction={buttons}
      size="md"
    />
  );
}

export default ModalDownloadBackupDataFailed;
